import { Component } from '@angular/core';
import { App, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { LoginModel, UserProvider } from '../../../providers/user/user';
import { MysportUserProfilePage } from '../../me/mysport/mysport-user-profile/mysport-user-profile';
import { RegistrationPage } from '../registration/registration';
import { LoaderProvider } from '../../../providers/loader/loader';
import { BackgroundGeolocation } from '@ionic-native/background-geolocation';
import { SessionProvider } from '../../../providers/session/session';
import { ConfigProvider } from '../../../providers/config/config';
import { AdsProvider } from '../../../providers/ads/ads';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { Subscription } from 'rxjs';
import { DarkMode, ThemeMode } from '../../../providers/dark-mode/dark-mode';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage{
  resolve: any;
  success: boolean = false;
  isIOS: boolean = false;
  isRootNav: boolean = true;
  isPremium:boolean=false;

  // darkMode
  toDark:boolean;
  toDarkSub:Subscription;

  constructor(
    public app: App,
    public translate: TranslateService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public userService: UserProvider,
    public loadingCtrl: LoaderProvider,
    private iab: InAppBrowser,
    private toastCtrl: ToastController,
    private sessionService: SessionProvider,
    private platform: Platform,
    private ads:AdsProvider,
    private appDetector: AppDetectorProvider,
    private darkModeService:DarkMode
  ) {
    this.platform.ready().then(async () => {
      this.isIOS = this.platform.is('ios');
      if (typeof this.navParams.data.isRootNav == "boolean") {
        this.isRootNav = this.navParams.get('isRootNav');
      }
      if (this.navParams.get('resolve'))
        this.resolve = this.navParams.get('resolve');
      this.sessionService.getLogin().then(mod => {
        this.loginModel = mod;
      });
    });
  }

  loginModel: LoginModel = { email: '', password: '' };
  rememberMe: boolean = true;
  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
    this.toDarkSub = this.darkModeService.themeModeSubject.subscribe((mode: ThemeMode) => {
      this.toDark = (mode === ThemeMode.DarkMode);
      let body = <HTMLElement>document.querySelector('body');

      if (this.toDark) {
        body.classList.add(ThemeMode.DarkMode);
      } else if (body && !this.toDark && body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.remove(ThemeMode.DarkMode);
      }
    });
  }

  login() {
    if (!navigator.onLine) {
      this.showLoader('NO_INTERNET_CONNECTION', 3000);
      return;
    }

    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    this.userService.login(this.loginModel).then(success => {
      loader.dismiss();

      if (success) {
        if (this.resolve) this.resolve(true);
        this.onLogin();
        this.saveLoginLocal();
        localStorage.setItem('premium', JSON.stringify(this.sessionService.profile.premium));
      } else {
        this.showToast("LOGIN_ERROR_NOT_VALID_CREDENTIALS", 4000);
      }


    }).catch((err) => {
      console.log("Login error: " + err);
    })
  }

  saveLoginLocal() {
    this.sessionService.saveLogin((this.rememberMe) ? this.loginModel : { emal: '', password: '' }).catch(err => console.log(err));
  }

  showToast(message: string, duration: number) {
    this.toastCtrl
      .create({
        message: this.translate.instant(message),
        showCloseButton: true,
        duration: duration
      })
      .present();
  }

  showLoader(message: string, duration: number) {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant(message)
    });
    loader.present();

    setTimeout(() => {
      loader.dismiss();
    }, duration);
  }

  onLogin() {
    this.sessionService.isLoged = true;
    this.sessionService.sendLoggedIn();

    // this.checkForOrganizerLogin();
    if (this.isRootNav) {
      if (this.app.getActiveNavs().length >= 1 || this.app.getRootNavs().length > 1) {
      (this.app.getRootNav() as NavController).pop();
      }
    } else {
      this.navCtrl.pop();
    }
  }

  checkForOrganizerLogin() {
    if (this.sessionService.profile.status.toLocaleUpperCase().includes("VERANSTALTER")) {
      this.toastCtrl.create({
        message: this.translate.instant('ORGANIZER_LOGIN_MESSAGE'),
        duration: 5000
      }).present();
      this.userService.logout();
    }
  }

  onGoogleLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginGoogle().subscribe(success => {
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  onFacebookLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginFacebook().then(success => {
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  onAppleLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginApple().then(success => {
      console.log('success: ' + success);
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  openForgotPass() {
    let browser = this.iab.create('https://spooorts.de/login/forgot-password', "_blank", { hardwareback: 'yes' });
    browser.show();
  }

  openReg() {
    if (this.resolve) {
      (this.app.getRootNav() as NavController).pop();
      this.app.getRootNav().push(RegistrationPage, { resolve: this.resolve });
    } else {
      (this.app.getRootNav() as NavController).pop();
      this.app.getRootNav().push(RegistrationPage);
    }
  }

  openLog() {
    this.app.getRootNav().push(MysportUserProfilePage);
  }

  ionViewWillLeave() {

  }
}



// WEBPACK FOOTER //
// /src/pages/login/login/login.ts